import { queryOptions, skipToken, useMutation } from "@tanstack/react-query";

import { api, BASE_API_URL_V2 } from "@/api/api";
import type {
  AdditionalService,
  GetFlightAvailabilityTokenBodyInputDto,
  GetFlightAvailabilityTokenOutputDtoV2,
} from "@/types/codegen";

interface FlightAvailabilityParams {
  index: string;
  searchResultKey: string;
  searchResultToken: string;
  itineraryIndex: number;
  mandatoryServices?: AdditionalService[];
  optionalServices?: AdditionalService[];
  upsellCode?: string | null;
}

export const flightAvailabilityQueryOptions = (
  params: FlightAvailabilityParams | null,
) =>
  queryOptions({
    queryKey: ["flight-availability", params] as const,
    queryFn: params
      ? ({ signal }) =>
          api.post<GetFlightAvailabilityTokenOutputDtoV2>(
            `/flights/${params.index}/availability`,
            {
              itineraryIndex: params.itineraryIndex,
              searchResultKey: params.searchResultKey,
              searchResultToken: params.searchResultToken,
              mandatoryServices: params.mandatoryServices ?? [],
              optionalServices: params.optionalServices ?? [],
              upsellCode: params.upsellCode ?? undefined,
            } satisfies GetFlightAvailabilityTokenBodyInputDto,
            {
              signal,
              baseURL: BASE_API_URL_V2,
            },
          )
      : skipToken,
    select: (data) => data.data.data,
    enabled: !!params,
    throwOnError: false,
    refetchOnMount: true,
    staleTime: 1000 * 5, // 5 seconds
  });

export const useFlightAvailabilityMutation = ({
  onSuccess,
}: {
  onSuccess: (data: GetFlightAvailabilityTokenOutputDtoV2) => void;
}) =>
  useMutation({
    mutationFn: (params: FlightAvailabilityParams) =>
      api.post<GetFlightAvailabilityTokenOutputDtoV2>(
        `/flights/${params.index}/availability`,
        params,
        {
          baseURL: BASE_API_URL_V2,
        },
      ),
    onSuccess: (data) => onSuccess(data.data),
  });
